const IndexPage = () => import(/* webpackChunkName: "index-page" */ '@/views/IndexPage.vue');
const ServicesPage = () => import(/* webpackChunkName: "service-page" */ '@/views/ServicesPage.vue');
const DataPolicyPage = () => import(/* webpackChunkName: "datapolicy-page" */ '@/views/DataPolicyPage.vue');
const ImpressumPage = () => import(/* webpackChunkName: "impressum-page" */ '@/views/ImpressumPage.vue');
const KarrierePage = () => import(/* webpackChunkName: "karriere-page" */ '@/views/KarrierePage.vue');
const KontaktPage = () => import(/* webpackChunkName: "kontakt-page" */ '@/views/KontaktPage.vue');
const SupportPage = () => import(/* webpackChunkName: "support-page" */ '@/views/SupportPage.vue');
const AGBPage = () => import(/* webpackChunkName: "abg-page" */ '@/views/AGBPage.vue');
const NotFoundPage = () => import(/* webpackChunkName: "notfound-page" */ '@/views/NotFoundPage.vue');
const MPage = () => import(/* webpackChunkName: "m-page" */ '@/views/MPage.vue');
const KontaktFormPage = () => import(/* webpackChunkName: "kontaktform-page" */ '@/views/KontaktFormPage.vue');
const ITBeratungPage = () => import(/* webpackChunkName: "itberatung-page" */ '@/views/ITBeratungPage.vue');

export default [
    {
    name: 'index',
    path: '/index',
    component: IndexPage,
  },

{
  name: 'itberatung',
  path: '/itberatung',
  component: ITBeratungPage,
  meta: {
    tracking: true,
    trackingName: 'itberatung'
  }
},
 
  {
    name: 'leistungen',  // Ensure this name matches exactly
    path: '/leistungen',
    component: ServicesPage,
  },
  {
    name: 'dataPolicy',
    path: '/data-policy',
    component: DataPolicyPage,
  },
  {
    name: 'impressum',
    path: '/impressum',
    component: ImpressumPage,
  },
  {
    name: 'karriere',
    path: '/karriere',
    component: KarrierePage,
  },
  {
    name: 'kontakt',
    path: '/kontakt',
    component: KontaktPage,
  },
  {
    name: 'support',
    path: '/support',
    component: SupportPage,
  },
  {
    name: 'agb',
    path: '/agb',
    component: AGBPage,
  },
    {
    name: 'kontaktform',
    path: '/kontaktform',
    component: KontaktFormPage,
     meta: {
    tracking: true,
    trackingName: 'kontaktform'  
  }
  },
  {
    name: 'm',
    path: '/m',
    component: MPage,
  },
    {
    name: 'root',
    path: '/',
    redirect: 'index',
  },
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: NotFoundPage,
  },
];
